import { useState } from 'react'
import { Briefcase, Share2, Cloud, Trash2, Edit2, Plus, X, Save, CheckCircle } from 'lucide-react'

export default function IntegrationHubPage() {
  const [data, setData] = useState({
    businessName: 'Cybertection Inc',
    industry: 'Cybersecurity',
    socialAccounts: [
      { id: 1, platform: 'Twitter', handle: '@cybertection' }
    ],
    cloudProjects: [
      { id: 1, name: 'AWS Production', region: 'us-east-1' }
    ]
  })

  const [editing, setEditing] = useState(null)
  const [editForm, setEditForm] = useState({})

  const handleDelete = (category, id) => {
    setData({
      ...data,
      [category]: data[category].filter(item => item.id !== id)
    })
  }

  const handleEdit = (category, item) => {
    setEditing({ category, id: item.id })
    setEditForm(item)
  }

  const saveEdit = () => {
    setData({
      ...data,
      [editing.category]: data[editing.category].map(item => 
        item.id === editing.id ? editForm : item
      )
    })
    setEditing(null)
  }

  return (
    <div className="max-w-4xl mx-auto space-y-8 p-6 text-white">
      <header>
        <h1 className="text-4xl font-black">Integration Management</h1>
        <p className="text-blue-300 mt-2">Manage your business assets and connections.</p>
      </header>

      {/* Business Profile */}
      <section className="bg-slate-900 p-6 rounded-xl border border-blue-500/20">
        <h2 className="text-xl font-bold flex items-center gap-2 mb-4"><Briefcase className="text-blue-400" /> Business Profile</h2>
        <div className="grid grid-cols-2 gap-4">
          <input className="bg-slate-800 p-3 rounded border border-blue-500/20" value={data.businessName} onChange={(e) => setData({...data, businessName: e.target.value})} />
          <input className="bg-slate-800 p-3 rounded border border-blue-500/20" value={data.industry} onChange={(e) => setData({...data, industry: e.target.value})} />
        </div>
      </section>

      {/* Social Accounts */}
      <section className="bg-slate-900 p-6 rounded-xl border border-blue-500/20">
        <h2 className="text-xl font-bold flex items-center gap-2 mb-4"><Share2 className="text-pink-400" /> Social Accounts</h2>
        {data.socialAccounts.map(account => (
          <div key={account.id} className="flex justify-between items-center bg-slate-800 p-4 rounded mb-2">
            {editing?.id === account.id ? (
              <input value={editForm.handle} onChange={(e) => setEditForm({...editForm, handle: e.target.value})} className="bg-slate-700 p-1 rounded" />
            ) : (
              <span>{account.platform}: {account.handle}</span>
            )}
            <div className="flex gap-2">
              {editing?.id === account.id ? <button onClick={saveEdit}><Save size={18} /></button> : <button onClick={() => handleEdit('socialAccounts', account)}><Edit2 size={18} /></button>}
              <button onClick={() => handleDelete('socialAccounts', account.id)}><Trash2 size={18} /></button>
            </div>
          </div>
        ))}
      </section>

      {/* Cloud Projects */}
      <section className="bg-slate-900 p-6 rounded-xl border border-blue-500/20">
        <h2 className="text-xl font-bold flex items-center gap-2 mb-4"><Cloud className="text-cyan-400" /> Cloud Projects</h2>
        {data.cloudProjects.map(project => (
          <div key={project.id} className="flex justify-between items-center bg-slate-800 p-4 rounded mb-2">
            {editing?.id === project.id ? (
              <input value={editForm.name} onChange={(e) => setEditForm({...editForm, name: e.target.value})} className="bg-slate-700 p-1 rounded" />
            ) : (
              <span>{project.name} ({project.region})</span>
            )}
            <div className="flex gap-2">
              {editing?.id === project.id ? <button onClick={saveEdit}><Save size={18} /></button> : <button onClick={() => handleEdit('cloudProjects', project)}><Edit2 size={18} /></button>}
              <button onClick={() => handleDelete('cloudProjects', project.id)}><Trash2 size={18} /></button>
            </div>
          </div>
        ))}
      </section>
    </div>
  )
}
